import { render, staticRenderFns } from "./comp_dpc-BrandsBoard.vue?vue&type=template&id=8491fe5e&scoped=true"
import script from "./comp_dpc-BrandsBoard.vue?vue&type=script&lang=js"
export * from "./comp_dpc-BrandsBoard.vue?vue&type=script&lang=js"
import style0 from "./comp_dpc-BrandsBoard.vue?vue&type=style&index=0&id=8491fe5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8491fe5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCol,VRow})
